import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DeleteIcon, LaunchIcon } from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const TaskCreateHelp = () => (
  <>
    <Typography variant="subtitle1">
      Create Tasks to delegate Yard duties to specific Crew members. Creating a
      new Task, adds it to their TO-DO list.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Task Type: </strong>
        </Typography>
        <ul>
          <li>
            <Typography>
              <strong>Generic: </strong>Assign custom Yard duties or resources.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Inventory Audit: </strong> Assign Inventory Audit.
              Displays an "Audit" drop-down field with list of active Audits.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Accept Inbound Shipment: </strong>
              Assign an Inbound Shipment to select Crew member. Displays a
              "Shipment" drop-down field with list of Placed shipments.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Load Outbound Shipment: </strong>
              Assign an Outbound Shipment to select Crew member. Displays a
              "Shipment" drop-down field with list of available shipments.
            </Typography>
          </li>
        </ul>
      </li>
      <li>
        <Typography>
          <strong>Shipment: </strong> Select from list of available shipments.
          Visible only when assigning Inbound / Outbound Shipment.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Due Date: </strong> Specify when the Task is due.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Late Date: </strong> Specify when the Task will be marked as
          late.
        </Typography>
      </li>
    </ul>
  </>
);

export const TaskEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1">
        Use Tasks to delegate Yard duties to specific Crew members. Once task is
        completed, Approve the completion.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Task Type: </strong>
          </Typography>
          <ul>
            <li>
              <Typography>
                <strong>Generic: </strong>Assign custom Yard duties or
                resources.
              </Typography>
            </li>
            <li>
              <Typography>
                <strong>Inventory Audit: </strong> Assign Inventory Audit.
              </Typography>
            </li>
            <li>
              <Typography>
                <strong>Accept Inbound Shipment: </strong> Assign an Inbound
                Shipment to select Crew member.
              </Typography>
            </li>
            <li>
              <Typography>
                <strong>Load Outbound Shipment: </strong>Assign an Outbound
                Shipment to select Crew member.
              </Typography>
            </li>
            <li>
              <Typography>
                <LaunchIcon className={classes.icon} />
                <strong> OPEN: </strong>
                Open corresponding Audit / Shipment record.
              </Typography>
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            <strong>Due Date: </strong> Specify when the Task is due.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Late Date: </strong> Specify when the Task will be marked as
            late.
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes user's access to the platform and deletes the User from
            "Users" list view.
          </Typography>
        </li>
      </ul>
    </>
  );
};
